import React from 'react';

import { Card, Table } from '@unimed-fesp/components';

import EmptyRelatorios from './EmptyRelatorios';
import TableBodyRelatorios from './TableBodyRelatorios';
import TableHeaderRelatorios from './TableHeaderRelatorios';

const Relatorios = ({ relatorios, handleNovoRelatorio }) => {
  const propJustify = {
    justifyCenter: relatorios.length <= 0,
    justifyStart: relatorios.length > 0,
  };

  return (
    <Card margin="0" alignCenter {...propJustify}>
      {relatorios.length <= 0 ? (
        <EmptyRelatorios handleNovoRelatorio={handleNovoRelatorio} />
      ) : (
        <Table head={<TableHeaderRelatorios />}>
          <TableBodyRelatorios relatorios={relatorios} />
        </Table>
      )}
    </Card>
  );
};

export default Relatorios;
